import type { AbstractSubmitStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { AbstractSubmitStep } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormCheckList, FormDecidable, ProgressButton } from "bm-ui-kit";
import type { FormCheckOptions } from "bm-ui-kit";
import type { FormApi } from "final-form";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import type { LoanGoal } from "./Step2.data";

export interface StepFields {
	homeMeetsTheOneYearRequirement: boolean;
	lessThenFiveThousandsSettlement: boolean;
	otherRequiredProducts: ("BABY_LOAN" | "MORTGAGE")[];
}

interface Props extends AbstractSubmitStepProps {
	loanGoal: LoanGoal;
	hasBabyLoanOption: boolean;
}

export class Step4 extends AbstractSubmitStep<StepFields, Props> {
	protected initValues(): StepFields {
		return {
			homeMeetsTheOneYearRequirement: undefined,
			lessThenFiveThousandsSettlement: undefined,
			otherRequiredProducts: [],
		};
	}

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Body>
					<FormDecidable
						label="5 ezer főnél kevesebb lakossal rendelkező településen valósítod meg lakáscélod?"
						name="lessThenFiveThousandsSettlement"
						disabled={disabled}
						required
					/>
					<FormCheckList
						label={
							<>
								A támogatások mellé <mark className="bg-success text-white">hitelt is</mark> igénybe
								vennél?
							</>
						}
						name="otherRequiredProducts"
						options={this.getotherRequiredProductsOptions()}
						disabled={disabled}
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
						state={submitState}
					>
						Tovább
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	private getotherRequiredProductsOptions(): FormCheckOptions<string> {
		const { hasBabyLoanOption } = this.props;

		return compact([
			hasBabyLoanOption && {
				label: "Babaváró hitel",
				value: "BABY_LOAN",
			},
			{
				label: "Lakáshitel",
				value: "MORTGAGE",
			},
		]);
	}

	protected getComponentName(): string {
		return "Step4";
	}
}
